import React from 'react';
import has from 'lodash/has';
import partial from 'lodash/partial';
import {Button, Grid} from 'semantic-ui-react';
import {FormattedMessage, FormattedNumber} from 'react-intl';
import {CurrenciesByLanguage} from 'utils/DBUtils';
import AutoSaveQuantityInput from './AutoSaveQuantityInput';
import {RetailerItemFormModes} from '../utils';

// possible columns for mix-and-match (by table mode) in the RewardsTable; each entry is a function
// that accept props and returns a colDetail object that ItemTable/ItemExplorer will recognize.
export default {
  Title: props => ({
    header: <FormattedMessage id='rewardsStore.table.column.title' />,
    fieldName: 'title',
    detailFunc: reward => (
      <div
        className='retailer-item-title'
        onClick={partial(props.openRetailerItemModal, RetailerItemFormModes.Update, reward)}>
        {reward.title}
      </div>
    ),
    canSort: true
  }),

  Points: props => ({
    header: <FormattedMessage id='rewardsStore.table.column.points' />,
    fieldName: 'points',
    detailFunc: reward => <FormattedNumber value={reward.points} />,
    canSort: true
  }),

  QuantityInput: props => ({
    header: <FormattedMessage id='rewardsStore.table.column.quantity' />,
    fieldName: 'allocated',
    detailFunc: reward => (
      <AutoSaveQuantityInput
        value={reward.allocated}
        onChange={partial(props.updateQuantity, props.lang, props.currentEscrowId, reward.id)}
        didSave={has(props.quantityUpdateSuccesses, reward.id)}
        apiError={has(props.quantityUpdateErrors, reward.id)} />
    ),
    canSort: true
  }),

  Allocated: props => ({
    header: <FormattedMessage id='rewardsStore.table.column.allocated' />,
    fieldName: 'allocated',
    detailFunc: reward => <FormattedNumber value={reward.allocated} />,
    canSort: true
  }),

  InStock: props => ({
    header: <FormattedMessage id='rewardsStore.table.column.inStock' />,
    fieldName: 'inStock',
    detailFunc: reward => <FormattedNumber value={reward.inStock} />,
    canSort: true
  }),

  Purchased: props => ({
    header: <FormattedMessage id='rewardsStore.table.column.purchased' />,
    detailFunc: reward => {
      const divProps = {
        className: 'purchase-info-link'
      };

      // disallow modal from opening if there's nothing to show.
      if (reward.purchased > 0) {
        divProps.onClick = partial(props.openPurchaseInfoModal, reward);
      } else {
        divProps.className += ' disabled';
      }

      return (
        <div {...divProps}>
          <FormattedNumber value={reward.purchased} />
        </div>
      );
    },
    canSort: true
  }),

  Price: props => ({
    header: <FormattedMessage id='rewardsStore.table.column.price' />,
    fieldName: 'price',
    detailFunc: reward => (
      <FormattedNumber
        style='currency'
        currency={CurrenciesByLanguage[props.lang]}
        value={reward.price} />
    ),
    canSort: true
  }),

  Cost: props => ({
    header: <FormattedMessage id='rewardsStore.table.column.cost' />,
    fieldName: 'cost',
    detailFunc: reward => (
      <FormattedNumber
        style='currency'
        currency={CurrenciesByLanguage[props.lang]}
        value={reward.cost} />
    ),
    canSort: true
  }),

  AddRemoveButtons: props => ({
    detailFunc: reward => (
      <div className='rewards-add-remove-buttons'>
        <Button
          circular
          icon='plus'
          onClick={partial(props.openIncreaseItemStockModal, reward)} />
        <Button
          circular
          icon='minus'
          onClick={partial(props.openDecreaseItemStockModal, reward)} />
      </div>
    )
  })
};



// WEBPACK FOOTER //
// ./public/pages/Rewards/RewardsTable/columns.jsx